import React from 'react'
import {useSelector} from "react-redux";

// components
import { ItemSearchForm } from '~/components/finalForms/templates/ItemSearchForm'
import {css} from "@emotion/react";

export const DetailTab = (props) => {
  const tabId = useSelector((state) => state.searchDrawerTab.id)
  return (
      <div css={wrapper}>
        {
          props.value === tabId &&
          <ItemSearchForm/>
        }
      </div>
  )
}

const wrapper = css`
  margin: 24px;
`